import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import {
	Button,
	RadioGroup,
	Dialog,
	DialogContent as MuiDialogContent,
	DialogActions as MuiDialogActions,
	IconButton,
	Typography,
	FormControl,
	FormLabel,
	Radio,
	InputLabel,
	Select,
	MenuItem,
	Grid,
	FormControlLabel,
	Checkbox,
	ListItemText,
	FormHelperText,
} from '@mui/material';
import Switch, { SwitchClassKey, SwitchProps } from '@mui/material/Switch';
import { Close as CloseIcon } from '@mui/icons-material';
import { CampaignAdvertisement } from '@horasys/bellplus/common/types';
import { Advertisement } from '@horasys/bellplus/common/types';
import { LocationAutoMode } from './location/LocationAutoMode';
import { LocationManualMode } from './location/LocationManualMode';
import { LocationGroupManualMode } from './locationGroup/LocationGroupManualMode';
import { CampaignStore } from 'store/reducers/campaignReducer';
import { DatePicker } from '@mui/x-date-pickers';
import AutoCompleteSelect from 'views/Common/AutoCompleteSelect';
import {
	advertisementDetailsbyId,
	checkAdvertisementByName,
} from 'services/advertising.service';
import theme from 'theme';
import { createStyles, withStyles } from '@mui/styles';
import { useAppDispatch, useAppSelector } from 'Stores/Hooks/hooks';
import { CampaignState, RESET_CAMPAIGN_ADVERTISEMENT_FORM, RESET_CAMPAIGN_ADVERTISEMENT_UI_STATE, UPDATE_CAMPAIGN_ADVERTISEMENT_FORM, deleteBlockedSlot, getAreasByCitiesDetails, getCitiesDetails, updateCampaignAdvertisementFormAction } from 'Stores/Slices/campaignSlice';
import { resetPopup,showPopup } from 'Stores/Slices/popUpSlice';
import { RootState } from 'Stores/store';
import { CssSelect } from 'views/Common/CssSelect';
const PREFIX = 'ChooseDevicesUpdated';

const classes = {
	root: `${PREFIX}-root`,
	root2: `${PREFIX}-root2`,
	root3: `${PREFIX}-root3`,
	switchBase: `${PREFIX}-switchBase`,
	thumb: `${PREFIX}-thumb`,
	track: `${PREFIX}-track`,
	checked: `${PREFIX}-checked`,
	focusVisible: `${PREFIX}-focusVisible`,
	formElement: `${PREFIX}-formElement`,
	selectEmpty: `${PREFIX}-selectEmpty`,
	mainContainer: `${PREFIX}-mainContainer`,
	uploadInput: `${PREFIX}-uploadInput`,
	uploadWrapper: `${PREFIX}-uploadWrapper`,
	paperchildGrid: `${PREFIX}-paperchildGrid`,
	searchLocations: `${PREFIX}-searchLocations`,
	saveGrid: `${PREFIX}-saveGrid`,
	templateDetails: `${PREFIX}-templateDetails`,
	formHalfElement: `${PREFIX}-formHalfElement`,
	allocateSlotButton: `${PREFIX}-allocateSlotButton`,
	slotResultsPage: `${PREFIX}-slotResultsPage`,
	confirmButtom: `${PREFIX}-confirmButtom`,
	statusButtons: `${PREFIX}-statusButtons`,
	budgetElement: `${PREFIX}-budgetElement`,
	appBar: `${PREFIX}-appBar`,
	title: `${PREFIX}-title`,
	radio: `${PREFIX}-radio`,
	checked2: `${PREFIX}-checked2`,
	checkboxColor: `${PREFIX}-checkboxColor`,
  select:`${PREFIX}-select`,
  inputLabel:`${PREFIX}-inputLabel`,
};

const Root = styled('div')(() => ({
	[`& .${classes.formElement}`]: {
		minWidth: '100%',
	},

	[`& .${classes.selectEmpty}`]: {
		marginTop: theme.spacing(2),
	},

	[`& .${classes.mainContainer}`]: {
		marginTop: theme.spacing(2),
	},

	[`& .${classes.uploadInput}`]: {
		fontSize: '100px',
		position: 'absolute',
		left: 0,
		top: 0,
		opacity: 0,
	},

	[`& .${classes.uploadWrapper}`]: {
		position: 'relative',
		overflow: 'hidden',
		display: 'inline-block',
	},

	[`& .${classes.paperchildGrid}`]: {
		padding: theme.spacing(1),
	},

	[`& .${classes.searchLocations}`]: {
		paddingLeft: theme.spacing(1),
		paddingRight: theme.spacing(1),
		minWidth: '50%',
	},

	[`& .${classes.saveGrid}`]: {
		marginTop: theme.spacing(2),
	},

	[`& .${classes.templateDetails}`]: {
		marginTop: theme.spacing(2),
	},

	[`& .${classes.formHalfElement}`]: {
		//minWidth: '100%',
		//marginTop: theme.spacing(3),
	},

	[`& .${classes.allocateSlotButton}`]: {
		marginLeft: theme.spacing(1),
		marginTop: theme.spacing(3),
		//padding: theme.spacing(1)
	},

	[`& .${classes.slotResultsPage}`]: {
		marginTop: theme.spacing(3),
		height: '100%',
		padding: theme.spacing(3),
	},

	[`& .${classes.confirmButtom}`]: {
		marginTop: theme.spacing(3),
		padding: theme.spacing(3),
    color:'#042630'
	},

	[`& .${classes.statusButtons}`]: {
		padding: theme.spacing(3),
	},

	[`& .${classes.budgetElement}`]: {
		width: '100%',
		height: '100%',
		marginLeft: theme.spacing(1),
		//padding: theme.spacing(1)
	},

	[`& .${classes.appBar}`]: {
		position: 'relative',
    backgroundColor:'#042630',
	},

	[`& .${classes.title}`]: {
		marginLeft: theme.spacing(2),
		flex: 1,
	},

	[`& .${classes.radio}`]: {
		'&$checked': {
			color: '#042630',
		},
	},

	[`& .${classes.checked}`]: {},

	[`& .${classes.checkboxColor}`]: {
		'&$checked': {
			color: '#042630',
		},
	},
  [`& .${classes.select}`]: {

    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#042630',
      [`& .${classes.inputLabel}`]: {color:'#042630'},
    },
	}
}));

interface Styles extends Partial<Record<SwitchClassKey, string>> {
	focusVisible?: string;
}

interface Props extends SwitchProps {
	classes: Styles;
}

export default function ChooseDevices({
	isOpenModel,
	advFormData,
	closeHandler,
	handleAdSubmitHandler,
}: {
	isOpenModel: boolean;
	advFormData: CampaignAdvertisement;
	closeHandler: any;
	handleAdSubmitHandler: any;

	advertisementList: Array<Advertisement>;
}) {

	const campaignStore: CampaignState = useAppSelector((state: RootState) => state.campaign);
	const {
		cities,
		areas,
		campaignAdvertisementState,
		campaignAdvertisementForm: advForm,
	} = campaignStore;

	const {
		showConfirm,
		toolbarMode,
		toolbarColSize,
		mainContainerAlign,
		isNewlyAllocatedSlots,
		isChooseDevicesPopupOpen,
		isChooseDevicesViewMode: modalDialogViewMode,
	} = campaignAdvertisementState;
	const dispatch = useAppDispatch();
	useEffect(() => {
		dispatch(getCitiesDetails());
	}, [dispatch]);
	const [error, setError] = useState<any>({});
	const popup = useAppSelector((state: RootState) => state.popup);
	const { confirmation } = popup;
	useEffect(() => {
		if (confirmation === 'agree') {
			dispatch(resetPopup());
			dispatch(deleteBlockedSlot(advForm.uuid));
		}
	}, [advForm.uuid, confirmation, dispatch]);

	const handleClose = () => {
		if (!modalDialogViewMode && isNewlyAllocatedSlots) {
			dispatch(showPopup('Are you sure that you want to delete slots?'));
		} else {
			resetForm();
		}
	};

	const resetForm = () => {
		dispatch(RESET_CAMPAIGN_ADVERTISEMENT_UI_STATE(null));
		dispatch(RESET_CAMPAIGN_ADVERTISEMENT_FORM(null));

		closeHandler();
	};

	const handleConfirmHandler = () => {
		handleAdSubmitHandler(advForm);
		resetForm();
	};

	const handleAdvertisementNameChange = async (event: any) => {
		if (event.target.value && event.target.value.id) {
			const selAd: Advertisement = await advertisementDetailsbyId(
				event.target.value.id,
			);
			dispatch(
				UPDATE_CAMPAIGN_ADVERTISEMENT_FORM({
					advertisement: selAd,
				}),
			);
		}
	};

	const handleFormChange = async (event: any) => {
		if (!event) {
			return;
		}
		event.preventDefault();
		const selectedCity: any = event.target.value;
		const selectedAreas: any = event.target.value;

		switch (event.target.name) {
			case 'cityid':
				dispatch(
					updateCampaignAdvertisementFormAction({
						selectedCities: selectedCity as string[],
					}),
				);
				dispatch(getAreasByCitiesDetails(selectedCity));
				break;

			case 'areaid':
				dispatch(
					updateCampaignAdvertisementFormAction({
						selectedAreas: selectedAreas as string[],
					}),
				);

				break;

			case 'budget':
				dispatch(
					updateCampaignAdvertisementFormAction({
						userBudget: event.target.value,
					}),
				);
				break;

			case 'advertisementId':
				// {
				// 	const filterAd:
				// 		| Advertisement
				// 		| undefined = campaignAdvertisements.find(
				// 		(ad: Advertisement) => event.target.value === ad.id,
				// 	);
				// 	if (filterAd) {
				// 		dispatch(
				// 			updateCampaignAdvertisementFormAction({
				// 				advertisement: advertisementResponse,
				// 			}),
				// 		);
				// 	}
				// }
				break;

			case 'isAuto':
				dispatch(
					updateCampaignAdvertisementFormAction({
						isAuto: event.target.checked,
					}),
				);

				break;

			case 'noOfTimes':
				dispatch(
					updateCampaignAdvertisementFormAction({
						noOfTimes: event.target.value,
					}),
				);

				break;
			case 'campaignSearchType':
				if (event.target.value === 'location') {
					dispatch(
						updateCampaignAdvertisementFormAction({
							typeOfSearch: event.target.value,
						}),
					);
				} else if (event.target.value === 'locationGroup') {
					dispatch(
						updateCampaignAdvertisementFormAction({
							typeOfSearch: event.target.value,
						}),
					);
				}
				break;

			default:
				break;
		}
	};

	const handleStartDateChange = (date: any) => {
		dispatch(
			updateCampaignAdvertisementFormAction({
				startDate: date,
				endDate: date,
			}),
		);
	};

	const handleEndDateChange = (date: any) => {
		dispatch(
			updateCampaignAdvertisementFormAction({
				endDate: date,
			}),
		);
	};

	const ITEM_HEIGHT = 48;
	const ITEM_PADDING_TOP = 8;
	const MenuProps = {
		PaperProps: {
			style: {
				maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
				width: 250,
			},
		},
	};

	return (
		<Root>
			<Dialog
				fullScreen
				onClose={handleClose}
				aria-labelledby="customized-dialog-title"
				open={isChooseDevicesPopupOpen}>
				<AppBar className={classes.appBar} style={{backgroundColor:'#042630', color:'#fff'}}>
					<Toolbar>
						<IconButton
							edge="start"
							color="inherit"
							onClick={handleClose}
							aria-label="close"
							size="large">
							<CloseIcon />
						</IconButton>
						<Typography variant="h6" className={classes.title}>
							Add Advertisement
						</Typography>
					</Toolbar>
				</AppBar>
        <Root style={{marginTop:"64px"}}>
				<DialogContent
					dividers
					classes={{
						root: classes.root
					}}>
					<form className={classes.paperchildGrid} noValidate style={{height:"700px"}}>
						<Grid
							container
							xs={toolbarColSize}
							direction={toolbarMode}
							spacing={3}>
							<Grid item xs>
								{/* <FormControl
									variant="outlined"
									className={classes.formElement}>
									<InputLabel htmlFor="advertisementId">
										Select Ad
									</InputLabel>
									<Select
										required
										fullWidth
										value={advForm.advertisement.id}
										onChange={handleFormChange}
										label="Select Ad"
										name="advertisementId"
										id="advertisementId"
										disabled={modalDialogViewMode}>
										{campaignAdvertisements != null &&
											campaignAdvertisements.map(
												(data: Advertisement, index: any) => (
													<MenuItem value={data.id} key={index}>
														{data.name}
													</MenuItem>
												),
											)}
									</Select>
								</FormControl> */}
								<FormControl
									variant="outlined"
									className={classes.formElement}>
									<AutoCompleteSelect
										name="advertisement"
										label="Advertisement Name"
										handleOnChange={handleAdvertisementNameChange}
										apiFunction={checkAdvertisementByName}
										selectedProperty="name"
										value={advForm.advertisement}
										isDisabled={false}
									/>
									{error && error.advertisementId && (
										<FormHelperText error={true}>
											{error.advertisementId}
										</FormHelperText>
									)}
								</FormControl>
							</Grid>
							<Grid item xs>
								<FormControl component="fieldset">
									<FormLabel component="legend" style={{color:"#a8a8a8"}}>
										Campaign Search Type
									</FormLabel>
									<RadioGroup
										row
										aria-label="Campaign Search Type"
										name="campaignSearchType"
										value={advForm.typeOfSearch}
										onChange={handleFormChange}>
										<FormControlLabel
											value="location"
											control={
												<Radio
                        style={{color:'#042630'}}
													classes={{
														root: classes.radio,
														checked: classes.checked,
													}}
												/>
											}
											label="Location"
										/>
										<FormControlLabel
											value="locationGroup"
											control={
												<Radio
                        style={{color:'#042630'}}

													classes={{
														root: classes.radio,
														checked: classes.checked,
													}}
												/>
											}
											label="Location Group"
										/>
									</RadioGroup>
								</FormControl>
							</Grid>
							<Grid item xs>
								<FormControl
									variant="outlined"
									className={classes.formElement}>
									<InputLabel htmlFor="cityid" className={classes.inputLabel}>Choose City</InputLabel>
									<CssSelect
										fullWidth
										name="cityid"
										multiple
										value={advForm.selectedCities}
										label="Select City"
										onChange={handleFormChange}
										id="cityid"
										required
										disabled={modalDialogViewMode}
										MenuProps={MenuProps}
										renderValue={(selected: any) =>
											selected.join(', ')
										}>
										{cities &&
											cities.length > 0 &&
											cities.map((data: any) => (

												<MenuItem value={data} key={data}>
													<Checkbox
														classes={{
															root: classes.checkboxColor,
															checked: classes.checked,
														}}
														checked={
															advForm &&
															advForm.selectedCities &&
															advForm.selectedCities.indexOf(
																data,
															) > -1
														}
													/>
													<ListItemText primary={data} />
												</MenuItem>
											))}
									</CssSelect>
									{error && error.cities && (
										<FormHelperText error={true}>
											{error.cities}
										</FormHelperText>
									)}
								</FormControl>
							</Grid>
							{advForm.typeOfSearch === 'location' && (
								<Grid item xs>
									<FormControl
										variant="outlined"
										className={classes.formElement}>
										<InputLabel htmlFor="areaid">
											Choose Area
										</InputLabel>
										<CssSelect
											fullWidth
											name="areaid"
											value={advForm.selectedAreas}
											label="Select Area"
											onChange={handleFormChange}
											id="areaid"
											required
											multiple
											disabled={modalDialogViewMode}
											MenuProps={MenuProps}
											renderValue={
												advForm.selectedAreas &&
													advForm.selectedAreas.length > 3
													? () => {
														return (
															advForm.selectedAreas.length.toString() +
															' areas selected'
														);
													}
													: (selected: any) =>
														selected.join(', ')
											}>
											{areas != null &&
												areas.map((data: any) => (
													<MenuItem value={data} key={data}>
														<Checkbox
															classes={{
																root:
																	classes.checkboxColor,
																checked: classes.checked,
															}}
															checked={
																advForm.selectedAreas.indexOf(
																	data,
																) > -1
															}
														/>
														<ListItemText primary={data} />
													</MenuItem>
												))}
										</CssSelect>
										{error && error.areas && (
											<FormHelperText error={true}>
												{error.areas}
											</FormHelperText>
										)}
									</FormControl>
								</Grid>
							)}

							<Grid item xs>
								<DatePicker
									value={advForm.startDate}
									onChange={handleStartDateChange}
									format="dd/MM/yyyy"
									label="Starting Date"
									disabled={modalDialogViewMode}
									disablePast={true}
									className={classes.formElement}
								/>
							</Grid>
							<Grid item xs>
								<DatePicker
									value={advForm.endDate}
									onChange={handleEndDateChange}
									format="dd/MM/yyyy"
									label="Ending Date"
									disabled={modalDialogViewMode}
									className={classes.formElement}
									disablePast={true}
								/>
							</Grid>
							{advForm.typeOfSearch === 'location' && (
								<Grid item xs>
									<FormControlLabel
										label="Do you want book slots automatically"
										control={
											<IOSSwitch
												checked={advForm.isAuto}
												onChange={handleFormChange}
												name="isAuto"
												classes={{
													root: classes.root3,
													switchBase: classes.switchBase,
													thumb: classes.thumb,
													track: classes.track,
													checked: classes.checked,
													focusVisible: classes.focusVisible
												}} />
										}
										className={classes.formElement}
										disabled={modalDialogViewMode}
									/>
								</Grid>
							)}
						</Grid>
						{advForm.typeOfSearch === 'location' && (
							<Grid
								container
								xs={12}
								className={classes.mainContainer}
								justifyContent={mainContainerAlign}>
								{advForm.isAuto ? (
									<LocationAutoMode
										error={error}
										setError={setError}
										isViewMode={modalDialogViewMode}
										campaignAdvertisement={advForm}
										handleFormChange={handleFormChange}
									/>
								) : (
									<LocationManualMode
										error={error}
										setError={setError}
										modalDialogViewMode={modalDialogViewMode}
									/>
								)}
							</Grid>
						)}
						{advForm.typeOfSearch === 'locationGroup' && (
							<>
								<Grid
									container
									xs={12}
									className={classes.mainContainer}
									justifyContent={mainContainerAlign}>
									<LocationGroupManualMode
										error={error}
										setError={setError}
										modalDialogViewMode={modalDialogViewMode}
									/>
								</Grid>
							</>
						)}
						{showConfirm && (
							<>
								{' '}
								<Grid container justifyContent="center">
									<div className={classes.statusButtons}>
										<Button
											className={classes.confirmButtom}
											variant="outlined"
											color="primary"
											onClick={handleConfirmHandler}
											disabled={modalDialogViewMode}>
											{' '}
											Confirm{' '}
										</Button>
										<Button
											className={classes.confirmButtom}
											disabled={modalDialogViewMode}
											onClick={handleClose}>
											{' '}
											Cancel{' '}
										</Button>
									</div>
								</Grid>
							</>
						)}
					</form>
				</DialogContent>
        </Root>
				<DialogActions
					classes={{
						root: classes.root2
					}}></DialogActions>
			</Dialog>
		</Root>
	);
}

const DialogContent = MuiDialogContent;

const DialogActions = MuiDialogActions;
const IOSSwitch = withStyles((theme) =>
	createStyles({
		root: {
			width: 42,
			height: 26,
			padding: 0,
			margin: theme.spacing(1),
		},
		switchBase: {
			padding: 1,
			'&$checked': {
				transform: 'translateX(16px)',
				color: theme.palette.common.white,
				'& + $track': {
					backgroundColor: '#52d869',
					opacity: 1,
					border: 'none',
				},
			},
			'&$focusVisible $thumb': {
				color: '#52d869',
				border: '6px solid #fff',
			},
		},
		thumb: {
			width: 24,
			height: 24,
		},
		track: {
			borderRadius: 26 / 2,
			border: `1px solid ${theme.palette.grey[400]}`,
			backgroundColor: theme.palette.grey[50],
			opacity: 1,
			transition: theme.transitions.create(['background-color', 'border']),
		},
		checked: {},
		focusVisible: {},
	}),
)(({ classes, ...props }: Props) => {
	return (
		<Switch
			focusVisibleClassName={classes.focusVisible}
			disableRipple
			classes={{
				root: classes.root,
				switchBase: classes.switchBase,
				thumb: classes.thumb,
				track: classes.track,
				checked: classes.checked,
			}}
			{...props}
		/>
	);
});
